import React from "react";

const Navlist = () => {
  return (
    <>
      <a href="#home">
        <li>Home</li>
      </a>
      <a href="#projects">
        <li>Projects</li>
      </a>
      <a href="#contact">
        <li>Contact</li>
      </a>
    </>
  );
};

export default Navlist;
